import React, { useEffect, useState } from "react";
import { TagProps } from "./../typings/tag";
import Tag from "./Tag";
import { NotRelevantTag } from "../helpers/Enums";

export interface EditTagQuestionProps {
  onSave: (tags: number[]) => void;
  title: string | undefined;
  subtitle: string | undefined;
  tags: TagProps[];
  buttonText: string;
  selectedTagValue?: number | undefined;
  skipButtonLink?: string;
}

const EditTagQuestion = ({
  onSave,
  title,
  subtitle,
  buttonText,
  tags,
  selectedTagValue,
  skipButtonLink,
}: EditTagQuestionProps) => {
  const [selectedTag, setSelectedTag] = useState<number>(
    selectedTagValue ?? -1
  );

  const enabled = selectedTag !== -1;

  const handleSubmit = async (
    event: React.FormEvent<HTMLFormElement>,
    defaultValue = false
  ) => {
    setSelectedTag(-1);
    event.preventDefault();
    onSave([defaultValue ? NotRelevantTag.NOT_RELEVANT : selectedTag]);
  };

  useEffect(() => {
    setSelectedTag(selectedTagValue ?? -1);
  }, [selectedTagValue]);

  console.log("11111");

  return (
    <>
      <div
        className="content_sec wf-section"
        style={{ paddingBottom: "100px" }}
      >
        <div className="signup_top_info">
          <div className="icon_info">
            <img
              src="~/assets/images/ic_info_smoke.svg"
              loading="lazy"
              alt=""
            />
          </div>
          <h2 className="signup_title">{title}</h2>
          <div>{subtitle}</div>
        </div>
        <div className="login_sec w-form">
          <form onSubmit={handleSubmit}>
            <div className="form_field_content login">
              <div className="form_links_group signup">
                {/* {console.log(tags)} need to change the tags to be as male and female */}
                {tags.map((tag, key) => {
                  const { text, value } = tag;
                  const isSelected = selectedTag === value;
                  const onPress = () => setSelectedTag(value);
                  return <Tag {...{ text, key, onPress, isSelected }} />;
                })}
              </div>
            </div>
            <div className="form_send_group">
              <div className="form_buttons_group filtering">
                <input
                  disabled={!enabled}
                  value={buttonText}
                  type="submit"
                  defaultValue="המשך"
                  data-wait=""
                  className={`button filtering w-button`}
                />
                {skipButtonLink && (
                  <a
                    href="#"
                    onClick={(e: any) => {
                      setSelectedTag(-1);
                      handleSubmit(e, true);
                    }}
                    className="skip_link"
                  >
                    {skipButtonLink}
                  </a>
                )}
              </div>
            </div>
          </form>
        </div>
      </div>
    </>
  );
};

export default EditTagQuestion;
